import { LuArrowUpRight } from "react-icons/lu";
import { useNavigate } from "react-router-dom";

const CourseRegCard = ({ title, status }) => {
  const navigate = useNavigate();


  return (
    <div class="w-full p-3 h-[237px] bg-[#DE222212] border border-[#EECDCD80] rounded-xl">
      <div class="">
          <div class="space-y-6">
            <p class="text-[#805050] font-weight-semibold font-14">{title}</p>
            <h1 className="text-4xl font-semibold text-brand-black">
              {status? "Registered" : "Not done"}
            </h1>
            {status ? (
              <div
                className="bg-white/45 p-2 flex items-center justify-between border border-[#E2D49A80] rounded-xl cursor-pointer hover:scale-105 transition-all ease-in-out"
                onClick={() =>
                  navigate(
                    "/course-reg/print"
                  )
                }
              >
                <p className="text-sm font-medium text-black">
                  Print course form
                </p>
                <div className="size-9 bg-[#F06565E5] rounded-lg flex justify-center items-center cursor-pointer group">
                  <LuArrowUpRight className="size-[18px] text-white group-hover:scale-125 transition-all ease-in-out" />
                </div>
              </div>
            ) : (
              <div
                className="bg-white/45 p-2 flex items-center justify-between border border-[#E2D49A80] rounded-xl cursor-pointer hover:scale-105 transition-all ease-in-out"
                onClick={() => navigate("/course-reg")}
              >
                <p className="text-sm font-medium text-black">
                  Go to Registration page
                </p>
                <div className="size-9 bg-[#F06565E5] rounded-lg flex justify-center items-center cursor-pointer group">
                  <LuArrowUpRight className="size-[18px] text-white group-hover:scale-125 transition-all ease-in-out" />
                </div>
              </div>
            )}
          </div>
      </div>
    </div>
  );
};

export default CourseRegCard;
